module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-down-regular.1e2fa613.svg";